module.exports = __webpack_public_path__ + "static/tigerroll-42be92e790df4ac2e8df15325135a05e.jpg";